export default __webpack_public_path__ + "static/media/isp.fca0fea3.jpeg";